import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface EmailVerificationData {
  email: string;
  lastOtpSentAt: number | null;
}

interface EmailVerificationStore extends EmailVerificationData {
  setVerificationData: (data: { email: string }) => void;
  setLastOtpSentAt: (timestamp: number | null) => void;
  clearVerificationData: () => void;
}

export const useEmailVerificationStore = create<EmailVerificationStore>()(
  persist(
    (set) => ({
      email: "",
      lastOtpSentAt: null,
      setVerificationData: (data) => set({ ...data, lastOtpSentAt: null }),
      setLastOtpSentAt: (timestamp) => set({ lastOtpSentAt: timestamp }),
      clearVerificationData: () => set({ email: "", lastOtpSentAt: null }),
    }),
    {
      name: "repayas-email-verification-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
